import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bg-gray-100 dark:bg-gray-700 text-center pt-12 pb-4 sm:pt-20 sm:pb-8 text-4xl sm:text-[4rem] font-serif italic tracking-tight text-gray-900 dark:text-white" }
const _hoisted_2 = {
  key: 0,
  class: "font-sans uppercase text-sm sm:text-lg tracking-normal not-italic"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Title',
  props: {
    subtitle: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("h1", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default"),
    _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
    (_ctx.subtitle)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.subtitle), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})